import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/navbar/cart-icon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/navbar/category-navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/navbar/navbar-home.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/navbar/navbar-mob.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globals/layouts/navbar/wishlist-icon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/best-selling.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/features.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/hero-banner-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/landing.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/marketed-products.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/new-arrivals.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/showcase.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/testimonials.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/type1-banner-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/type2-banner-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/type3-banner-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/type4-banner-section.tsx");
